var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"h-12 w-full flex justify-between border-b border-gray-10 bg-white"},[_c('div',{staticClass:"flex"},[_vm._t("left")],2),_c('div',[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }